import { gql } from '@apollo/client';

export const CREATE_PACKAGE = gql`
    mutation CreatePackages($name: String!, $description: String!, $package_type: String!, $package_order:Int!, $information:String) {
    createPackages(name: $name, description: $description, package_type: $package_type, package_order:$package_order, information:$information) {
        error {
            message
            code
            field
        }
        data {
            package {
                created_at
                updated_at
                package_order
                information
                id
                name
                description
                package_type
            }
        }
    }
}
`;

export const UPDATE_PACKAGE = gql`
   mutation UpdatePackage($name: String!, $description: String!, $package_type: String!, $package_id:UUID!, $package_order:Int!, $information:String) {
    updatePackage(name: $name, description: $description, package_type: $package_type , package_id:$package_id, package_order:$package_order, information:$information ) {
        error {
            message
            code
            field
        }
        data {
            package {
                package_type
                created_at
                updated_at
                id
                name
                description
                package_order
                information
            }
        }
    }
}
`;
export const DELETE_PACKAGE = gql`
   mutation DeletePackage($package_id: UUID!) {
    deletePackage(package_id: $package_id) {
        data {
            message
        }
        error {
            message
            code
            field
        }
    }
}

`;

